import React, { useEffect, useState } from "react";
import { useParams, useHistory } from 'react-router-dom'
import { Carousel, Modal } from "react-bootstrap";
import "../../assets/css/newRegistration.css";
import api from "../../seller-apis/api";
import { useAlert } from "react-alert";


const RegisterSuccess = () => {
    const { id } = useParams();
    const [show, setShow] = useState(false);
    const [showError, setShowError] = useState(false);
    const alert = useAlert()
    useEffect(() => {
        localStorage.removeItem('lead');

        // Check if id is undefined, null or empty
        if (!id || id === undefined || id === null || id === "" || id === "undefined") {
            setShowError(true);
            setShow(true);
            return;
        }

        api.vendorLead.getVendorLead(id).then((res) => {
            if (res?.message === "Verified") {
                setShow(true);
            } else {
                window.location.assign("/login");
            }
        }
        ).catch((err) => {
            alert.error("Something went wrong, please try again later.");
            console.error("Error fetching vendor lead:", err);
            setShow(false);
        }
        );
    }, [])



    if (show) {
        return (
            <>
                <div className="new_Registration_Cntn">
                    {/* Header */}
                    <div className="n_Reg_Header d-flex" id="first_panel">
                        <div className="n_Reg_Header_logo w-50">
                            <img className="" src="/reg_header_logo.png" alt="img"></img>
                        </div>
                        <div className="n_Reg_Header_buttons w-50 m-auto">
                            <button
                                className="n_Reg_Header_buttons_ft"
                                onClick={() =>
                                    window.open(
                                        "https://play.google.com/store/apps/details?id=com.toolsvilla.seller",
                                        "_blank"
                                    )
                                }
                            >
                                <i className="fa fa-mobile me-1" aria-hidden="true"></i> Download
                                App
                            </button>
                            <button
                                className="n_Reg_Header_buttons_ft"
                                onClick={() => window.location.assign("/login")}
                            >
                                <i className="fa fa-user me-1" aria-hidden="true"></i> Log In
                            </button>
                            <button className="n_Reg_Header_buttons_lb">Seller Support</button>
                        </div>
                    </div>

                    {/* 1 section */}
                    <div
                        className=
                        "n_Reg_first_cntn leads-form-with-tag form-bg dis-flex"

                    >
                        <div className="rotpbox">
                            <div className="res-done">
                                <div>
                                    {showError ?
                                        <>
                                            <div>
                                                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                            </div>
                                            <div>
                                                Some error occurred
                                            </div></> :
                                        <>
                                            <div>
                                                <img src="/step-done.webp" alt="icon" />
                                            </div>
                                            <div>
                                                Your account registration is received by us.Our team will contact you soon.
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 2 section */}
                    <div className="n_Reg_second_cntn restration-desk">
                        <img src="/registration_1.png" className="" alt="img"></img>
                    </div>
                    <div
                        className="n_Reg_second_cntn  restration-mob"
                        style={{ display: "none" }}
                    >
                        <img src="/registration_1_mob.png" className="" alt="img"></img>
                    </div>

                    {/* 3 section */}
                    <div className="n_Reg_third_cntn">
                        <div className="n_Reg_third_first">
                            <div className="">
                                <p> 6 Simple Steps </p>
                                <p> to Start Your Business</p>
                            </div>
                            <div className="down-arrow"> <img src="/arrow-down.png" /></div>
                        </div>
                        <div className="n_Reg_third_cards_cntn">
                            <div className="n_Reg_third_cards">
                                <img src="/r_des_3card_1.png" alt="img"></img>
                            </div>
                            <div className="n_Reg_third_cards">
                                <img src="/r_des_3card_2.png" alt="img"></img>
                            </div>
                            <div className="n_Reg_third_cards">
                                <img src="/r_des_3card_3.png" alt="img"></img>
                            </div>
                            <div className="n_Reg_third_cards">
                                <img src="/r_des_3card_4.png" alt="img"></img>
                            </div>
                            <div className="n_Reg_third_cards">
                                <img src="/r_des_3card_5.png" alt="img"></img>
                            </div>
                            <div className="n_Reg_third_cards">
                                <img src="/r_des_3card_6.png" alt="img"></img>
                            </div>
                        </div>
                    </div>

                    {/* 4 section */}
                    <div className="n_Reg_fourth_cntn">
                        <div className="">What makes people love Toolsvilla</div>
                        <div className="n_Reg_fourth_card_cntn">
                            <Carousel
                                className="my-4 carousel text-center  restration-desk"
                                pause="hover"
                            >
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review1.png" alt="img"></img>
                                    <img src="/reg_review2.png" alt="img"></img>
                                    <img src="/reg_review3.png" alt="img"></img>
                                </Carousel.Item>
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review4.png" alt="img"></img>
                                    <img src="/reg_review5.png" alt="img"></img>
                                    <img src="/reg_review6.png" alt="img"></img>
                                </Carousel.Item>
                            </Carousel>
                            <Carousel
                                className="my-4 carousel text-center restration-mob"
                                pause="hover"
                            >
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review1.png" alt="img"></img>
                                </Carousel.Item>
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review2.png" alt="img"></img>
                                </Carousel.Item>
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review3.png" alt="img"></img>
                                </Carousel.Item>
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review4.png" alt="img"></img>
                                </Carousel.Item>
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review5.png" alt="img"></img>
                                </Carousel.Item>
                                <Carousel.Item className="home_carousel_cntn">
                                    <img src="/reg_review6.png" alt="img"></img>
                                </Carousel.Item>
                            </Carousel>
                        </div>
                    </div>

                    {/* 5 section */}
                    <div className="n_Reg_fifth_cntn">
                        <div className="row">
                            <div className="col-4">
                                <div className="d-flex m-auto">
                                    <div className="n_Reg_fifth_foot_logo">
                                        <img src="/logo-search.png" alt="image" />
                                    </div>
                                    <div className="n_Reg_fifth_foot_logo_text">
                                        <span className="n_Reg_fifth_foot_logo_text_1">
                                            TOOLSVILLA
                                        </span>
                                        <br></br>
                                        <span className="n_Reg_fifth_foot_logo_text_2">
                                            Sell on India’s leading B2B E-commerce Marketplace
                                        </span>
                                    </div>
                                </div>
                                <div className="n_Reg_fifth_cntn_logo_btn">
                                    <button
                                        onClick={() =>
                                            document.getElementById("first_panel").scrollIntoView()
                                        }
                                    >
                                        START SELLING
                                    </button>
                                </div>
                            </div>
                            <div className="col-1">
                                {/* <p className='n_Reg_fifth_heading'>Quick Links</p>
                 <ul className='n_Reg_fifth_ul n_Reg_fifth_ul_quicklinks'>
                     <li><NavLink exact to="/">Login</NavLink></li>
                     <li><NavLink exact to="/">How it works</NavLink></li>
                     <li><NavLink exact to="/">Shipping & Returns</NavLink></li>
                     <li><NavLink exact to="/">Terms & Conditions</NavLink></li>
                     <li><NavLink exact to="/">Privacy Policy</NavLink></li>
                     <li><NavLink exact to="/">Learning centre</NavLink></li>
                 </ul> */}
                            </div>
                            <div className="col-4">
                                <p className="n_Reg_fifth_heading">Contact</p>
                                <ul className="n_Reg_fifth_ul n_Reg_fifth_ul_contacts">
                                    <li>
                                        <a href="mailto:sellersupport@toolsvilla.com">
                                            sellersupport@toolsvilla.com
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-3 d-flex justify-content-center">
                                <div className="n_Reg_fifth_cntn_social_icons">
                                    <img
                                        src="/yt_rg_icon.png"
                                        alt="image"
                                        onClick={() =>
                                            window.open(
                                                " https://www.youtube.com/@toolsvilla_tv",
                                                "_blank"
                                            )
                                        }
                                    />
                                </div>
                                <div className="n_Reg_fifth_cntn_social_icons">
                                    <img
                                        src="/fb_rg_icon.png"
                                        alt="image"
                                        onClick={() =>
                                            window.open(
                                                "https://www.facebook.com/toolsvilla/",
                                                "_blank"
                                            )
                                        }
                                    />
                                </div>
                                <div className="n_Reg_fifth_cntn_social_icons">
                                    <img
                                        src="/in_rg_icon.png"
                                        alt="image"
                                        onClick={() =>
                                            window.open(
                                                "https://www.instagram.com/toolsvilla/?hl=en",
                                                "_blank"
                                            )
                                        }
                                    />
                                </div>
                                {/* <div className='n_Reg_fifth_cntn_social_icons'>
                     <img src='./li_rg_icon.png' alt='image' onClick={() => window.open("https://www.facebook.com/toolsvilla/", "_blank")} />
                 </div> */}
                            </div>
                        </div>
                        <div className="n_Reg_fifth_cntn_copyright">
                            <p>Copyright @2022 toolsvilla</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    else {
        return (
            <>
            </>
        )
    }
};

export default RegisterSuccess;
